/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnrichedOptimizerTrade } from './EnrichedOptimizerTrade';
import {
    EnrichedOptimizerTradeFromJSON,
    EnrichedOptimizerTradeFromJSONTyped,
    EnrichedOptimizerTradeToJSON,
} from './EnrichedOptimizerTrade';
import type { OptimizationMeta } from './OptimizationMeta';
import {
    OptimizationMetaFromJSON,
    OptimizationMetaFromJSONTyped,
    OptimizationMetaToJSON,
} from './OptimizationMeta';
import type { OptimizerError } from './OptimizerError';
import {
    OptimizerErrorFromJSON,
    OptimizerErrorFromJSONTyped,
    OptimizerErrorToJSON,
} from './OptimizerError';

/**
 * 
 * @export
 * @interface OptimizationResult
 */
export interface OptimizationResult {
    /**
     * 
     * @type {OptimizationMeta}
     * @memberof OptimizationResult
     */
    meta: OptimizationMeta;
    /**
     * 
     * @type {Array<EnrichedOptimizerTrade>}
     * @memberof OptimizationResult
     */
    trades: Array<EnrichedOptimizerTrade>;
    /**
     * 
     * @type {Array<OptimizerError>}
     * @memberof OptimizationResult
     */
    errors: Array<OptimizerError>;
}

/**
 * Check if a given object implements the OptimizationResult interface.
 */
export function instanceOfOptimizationResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "trades" in value;
    isInstance = isInstance && "errors" in value;

    return isInstance;
}

export function OptimizationResultFromJSON(json: any): OptimizationResult {
    return OptimizationResultFromJSONTyped(json, false);
}

export function OptimizationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizationResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': OptimizationMetaFromJSON(json['meta']),
        'trades': ((json['trades'] as Array<any>).map(EnrichedOptimizerTradeFromJSON)),
        'errors': ((json['errors'] as Array<any>).map(OptimizerErrorFromJSON)),
    };
}

export function OptimizationResultToJSON(value?: OptimizationResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': OptimizationMetaToJSON(value.meta),
        'trades': ((value.trades as Array<any>).map(EnrichedOptimizerTradeToJSON)),
        'errors': ((value.errors as Array<any>).map(OptimizerErrorToJSON)),
    };
}

